import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, Menu, Placeholder } from 'semantic-ui-react';

import './TabBar.css';
import * as config from '../config';
import EnvLabel from './EnvLabel';
import Launcher from './Launcher';
import AuthLabel from './AuthLabel';

const TabBar = (props) => {
  const {
    availableTabs,
    launcherOpen,
    openTabs,
    onCloseLauncher,
    onCloseTab,
    onLaunch,
    onToggleLauncher,
  } = props;
  return (
    <Menu>
      <Menu.Item fitted="vertically">
        <Launcher
          tabs={availableTabs}
          open={launcherOpen}
          onClose={onCloseLauncher}
          onLaunch={onLaunch}
          onToggle={onToggleLauncher}
        />
      </Menu.Item>
      {openTabs.map((tab) => (
        <Menu.Item as={NavLink} to={tab.url} key={tab.url}>
          <div className="ds__TabBar__tab-icon">{tab.icon}</div> {tab.label}
          {onCloseTab &&
            <Icon
              link
              name="close"
              color="grey"
              className="ds__TabBar__tab-close"
              onClick={(e) => {
                e.preventDefault();
                onCloseTab(tab);
              }}
            />
          }
        </Menu.Item>
      ))}
      <Menu.Menu position="right">
        <Menu.Item className="borderless" fitted>
          <EnvLabel env={config.DS_ENV} />
        </Menu.Item>
        <Menu.Item className="borderless" fitted>
          <AuthLabel />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
};

export default TabBar;

TabBar.Placeholder = (props) => (
  <Menu>
    <PlaceholderTab />
    <PlaceholderTab />
    <PlaceholderTab />
  </Menu>
);

const PlaceholderTab = (props) => (
  <Menu.Item>
    <Placeholder style={{width: '98px'}}>
      <Placeholder.Header>
        <Placeholder.Line length="full" />
      </Placeholder.Header>
    </Placeholder>
  </Menu.Item>
);
